import { render } from "./BaseAccordionBody.vue?vue&type=template&id=32388aa0"
import script from "./BaseAccordionBody.vue?vue&type=script&lang=js"
export * from "./BaseAccordionBody.vue?vue&type=script&lang=js"

import "./BaseAccordionBody.vue?vue&type=style&index=0&id=32388aa0&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__